import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  NavbarText,
} from 'reactstrap';

function NavBar(args) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <Navbar  color="dark"
    dark {...args}>
        <NavbarBrand>PolygonRockers</NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="me-auto" navbar>
          <NavbarText>Links Below</NavbarText>
            <NavItem>
              <NavLink href="https://opensea.io/collection/polygonrocker">OpenSea</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="https://linktr.ee/multipersonalitynfts">
                Linktr.ee
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="https://twitter.com/PolygonRockers">
                Twitter
              </NavLink>
            </NavItem>
          <NavItem>
            <NavLink href="https://discord.gg/WVY5CRQJ">
              Discord
              </NavLink>
          </NavItem>
          </Nav>
         
        </Collapse>
      </Navbar>
    </div>
  );
}

export default NavBar;